import AccordionContent from "@/components/atoms/Accordion/accordion-content"
import AccordionTrigger from "@/components/atoms/Accordion/accordion-tirgger"
import { Checkbox } from "@/components/atoms/Checkbox/checkbox"
import { Label } from "@/components/atoms/Label/label"
import { AccordionItem } from "@/components/organisms/Accordion/accordion"
import Rating from "../Rating/rating"

interface RatingFacetProps {
  id: string
  title: string
  distribution: Record<string, number> | undefined
  isChecked: (value: string) => boolean
  onCheckedChange: (checked: boolean, value: string) => void
}

export function RatingFacet({ id, title, distribution, isChecked, onCheckedChange }: RatingFacetProps) {
  const distributionsEntries = Object.entries(distribution || {})
  const hasNoResults = distributionsEntries.length === 0

  return (
    <AccordionItem value={id}>
      <AccordionTrigger className="p-2 text-base">{title}</AccordionTrigger>
      <AccordionContent>
        {hasNoResults ? (
          <p className="text-[14px] text-neutral-500">No {title.toLowerCase()} found</p>
        ) : (
          <div className="grid gap-2">
            {distributionsEntries.map(([value], index) => {
              const ratingValue = parseInt(value)
              return (
                <Label key={value + index} className="flex items-center gap-2 font-normal text-gray-500">
                  <Checkbox
                    name={value}
                    checked={isChecked(value)}
                    onCheckedChange={(checked) => onCheckedChange(!!checked, value)}
                  />
                  <Rating stars={ratingValue} /> {ratingValue !== 5 && `& up`}
                </Label>
              )
            })}
          </div>
        )}
      </AccordionContent>
    </AccordionItem>
  )
}
